import React from 'react';
import { Box } from '@mui/material';

interface SphereProps {
  radius?: number;
  unit?: string;
  color?: string;
  strokeColor?: string;
}

export const Sphere: React.FC<SphereProps> = ({
  radius = 3,
  unit = 'cm',
  color = '#e6d3ff',
  strokeColor = '#9c27b0'
}) => {
  const cx = 50;
  const cy = 50;
  
  const scale = 35 / radius; 
  const R = radius * scale;
  
  const r_proj = R * Math.sqrt(1.5);
  const rx = r_proj;
  const ry = R * Math.SQRT1_2; 

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
      <svg
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid meet"
        style={{ width: '100%', maxWidth: '320px', height: '320px', display: 'block' }}
      >
        <defs>
          <radialGradient id="sphereGrad" cx="35%" cy="35%" r="65%">
            <stop offset="0%" stopColor="#ffffff" stopOpacity={0.8} />
            <stop offset="40%" stopColor={color} stopOpacity={0.8} />
            <stop offset="100%" stopColor={color} stopOpacity={1.0} />
          </radialGradient>
        </defs>

        <circle cx={cx} cy={cy} r={r_proj} fill="url(#sphereGrad)" stroke={strokeColor} strokeWidth={1.5} />
        
        {/* Equator (Isometric circle) */}
        <path d={`M ${cx - rx} ${cy} A ${rx} ${ry} 0 0 1 ${cx + rx} ${cy}`} fill="none" stroke={strokeColor} strokeWidth={1} strokeDasharray="2,2" opacity={0.5} />
        <path d={`M ${cx - rx} ${cy} A ${rx} ${ry} 0 0 0 ${cx + rx} ${cy}`} fill="none" stroke={strokeColor} strokeWidth={1} opacity={0.6} />

        {/* Radius line and label */}
        <circle cx={cx} cy={cy} r={1.2} fill={strokeColor} />
        <line x1={cx} y1={cy} x2={cx + rx} y2={cy} stroke={strokeColor} strokeWidth={1.5} strokeDasharray="1,2" opacity={0.8} />
        
        <text x={cx + rx / 2} y={cy - 2} fontSize={3.5} fill="#374151" fontWeight={600} textAnchor="middle">r = {radius} {unit}</text>
      </svg>
    </Box>
  );
};

export default Sphere;
